import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  mutation deleteCard($projectId: String!, $workflowId: String!, $eventId: String!, $eventIndex: Int!, $cardId: ID!, $cardIndex: Int!, $expectedVersion: Int!, $cardDescription: String) {
    deleteCard(projectId: $projectId, workflowId: $workflowId, eventId: $eventId, eventIndex: $eventIndex, cardId: $cardId, cardIndex: $cardIndex, expectedVersion: $expectedVersion, cardDescription: $cardDescription) {
      ...WorkflowFields
    }
  }
`
